export const Column = (props) => null;
